<template>
  <div class="card">
    {{ dataInputs }}
    <label :for="tabName+paramIndex"></label>
    <input type="checkbox" :name="tabName+paramIndex" v-model="dataInputs" :value="[tabName, param.value]" @change="onChangeCheckBox(param)" :disabled="param.count == 0">
    <span class="card-value" :class="((param.count == 0) ? 'noactive' : '')">{{(param.translation) ? param.translation : Number(param.value)}} {{(suffix) ? suffix : ''}}</span>
    <span class="card-count" :class="((param.count == 0) ? 'noactive' : '')">({{param.count}})</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "InputCheckBox",
  props: ["param", "paramIndex", "tabName", "suffix"], // , "inputType","tabName","suffix","parentTranslation"], // ["tabId", "tabName", "param", "count", "quantity", "single"],
  data() {
    return {
      searchInp: '',
      value: [0, 10000],
      value_min: 0,
      value_max: 10000,
      dataInputs: []
    };
  },
  computed: {
    ...mapGetters('products',["dataValue", "attributes_active","attributes_position"]),
    searching () {
      let searchArr = []
      let orders = this.params
      const self = this
      if (orders && this.searchInp != '') {
        Object.keys(orders).forEach(function (key) {
          if ((orders[key].value && orders[key].value.toLowerCase().includes(self.searchInp.toLowerCase())) || (orders[key].translation && orders[key].translation.toLowerCase().includes(self.searchInp.toLowerCase()))) {
            searchArr.push(orders[key])
          }
        })
      } else {
        searchArr = orders
      }
      return searchArr
    }
  },
  watch: {
    attributes_active (newValue) {
      this.changeValuesAxios(newValue)
    }
  },
  methods: {
    searchingInputs () {
      // console.log(this.searchInp)
    },
    changeValuesAxios (data) {
      console.log(data)
      if (data[this.tabName]) {
        this.dataInputs = []
        data[this.tabName]['values'].forEach(element => {
          this.dataInputs.push([this.tabName, element])
        });
      } else {
        this.dataInputs = []
      }
    },
    onChangeCheckBox (param) {
      console.log(this.dataInputs)
      // this.setDataValue(this.dataInputs, param)
    },
    setDataValue (item, param) {
      console.log('--- setDataValue ---')
      console.log(param)
      console.log('----')
      console.log(item)
      var output = []
      // item.forEach(element => {
      //   if(output[element[0]] && output[element[0]]['values']) {
      //     output[element[0]]['values'].push(element[1])
      //     if (this.parentTranslation) {
      //       output[element[0]]['translationParent'] = this.parentTranslation
      //     }
      //     if (param.translation) {
      //       output[element[0]]['translationChild'] = param.translation
      //     }
      //   } else {
      //     output[element[0]] = []
      //     output[element[0]]['values'] = []
      //     output[element[0]]['values'].push(element[1])
      //     if (this.parentTranslation) {
      //       output[element[0]]['translationParent'] = this.parentTranslation
      //     }
      //     if (param.translation) {
      //       output[element[0]]['translationChild'] = param.translation
      //     }
      //   }
      // });
      // if (item.length == 0) {
      //   output[this.tabName] = []
      // }
      console.log( output)
      this.$store.dispatch('products/set_data_values', output)
    }
  },
};
</script>

<style scoped>
  .card input {
    width:20px;
  }
  .card-count {
    font-size: 11px;
    color: #5494ff;
  }
 .noactive {
    color: rgb(214, 214, 214);
  }
  .card-value {
    display: inline;
    white-space: break-spaces;
  }
  .pos-vertical {
    max-height: 300px;  overflow-y: auto;
  }
  /* .pos-horizon {
    height: 130px;  overflow-y: auto;
  } */
  /* =============== CHECKBOX ================= */
  #FormCheckbox {
    display: table;
    margin-bottom: 0px;
  }
  ul.TemplateParametrs #FormCheckbox {
    display: table;
    margin-bottom: 5px;
  }
  #FormCheckbox h5 {
    margin-left: 30px !important;
    position: relative;
    white-space: normal;
    float: left;
    top: 2px;
  }
  #FormCheckbox .md-checkbox {
    display: flex !important;
    margin: 5px !important;
  }
  .container {
    display: block;
    position: relative;
    padding-left: 5px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    height: 6px;
    margin-left: 2px;
  }
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border: 2px #737373 solid;
    border-radius: 2px;
  }
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }
  .container input:checked ~ .checkmark {
    background-color: #448aff;
    border: none;
  }
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .container input:checked ~ .checkmark:after {
    display: block;
  }
  .container .checkmark:after {
    left: 6px;
    top: 2px;
    width: 8px;
    height: 13px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>




// WEBPACK FOOTER //
// src/components/fields/CheckBox.vue